'use strict';

var Event = require('../util/event');
var Util = require('../util/index');

module.exports = function interceptFetch() {
    var enableLogTrace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var project = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (typeof window.fetch !== 'function' || window.fetch._owl) return;

    var protocol = window.location && window.location.protocol;
    if (protocol === 'file:') return;

    var _fetch = window.fetch;
    window.fetch = function (input) {
        var args = Array.prototype.slice.call(arguments, 0);
        var fetchUrl = (input && typeof input !== 'string' ? input.url : input) || '';
        var init = args[1] || {};
        var origin = Util.getOrigin();
        if (init.method === 'HEAD' || init.mode === 'no-cors') return _fetch.apply(window, args);

        var traceid = void 0;
        try {
            if (enableLogTrace && Util.checkSameOrigin(fetchUrl, origin) && project) {
                traceid = Util.traceid();
                init.headers = new Headers(init.headers);
                init.headers.append('M-TRACEID', traceid);
                init.headers.append('M-APPKEY', 'fe_' + project);
                args[1] = init;
            }
        } catch (e) {
            Util.reportSysError(e);
        }

        var startTime = +new Date();
        return _fetch && _fetch.apply(window, args).then(function (res) {
            try {
                if (!res || typeof res.clone !== 'function') return res;

                var copy = res.clone();
                var resHeaders = copy.headers;
                var xForbidReason = '';
                if (resHeaders && typeof resHeaders.get === 'function') {
                    var contentType = resHeaders.get('content-type');
                    if (contentType && !/(text)|(json)/.test(contentType)) return res;

                    xForbidReason = resHeaders.get('x-forbid-reason') || '';
                }
                copy.text().then(function (response) {
                    Event.trigger('fetchCall', {
                        url: fetchUrl,
                        duration: +new Date() - startTime,
                        isSuccess: true,
                        ok: copy.ok,
                        response: response,
                        statusCode: copy.status,
                        statusText: copy.statusText,
                        xForbidReason: xForbidReason,
                        traceid: traceid
                    });
                });

                return res;
            } catch (e) {
                Util.reportSysError(e);
                return res;
            }
        }).catch(function (err) {
            Event.trigger('fetchCall', {
                url: fetchUrl,
                duration: +new Date() - startTime,
                isSuccess: false,
                errName: err.name,
                errMsg: err.stack || err.message,
                traceid: traceid
            });

            throw err;
        });
    };

    window.fetch._owl = true;
};